const attachFileList = () => {
 const DATA_WRAP_NAME = `attach-file-wrap`;
 const DATA_MAX_ITEM_SIZE = `max-item-size`;
 const DATA_MAX_FILE_SIZE = `max-file-size`;
 const DATA_FILE_ACCEPT = `file-accept`;
 const DATA_CAPTURE = `capture`;
 const DATA_NAME_ATTRIBUTE_PREFIX = `file-name-prefix`;

 const CLASS_ITEM_WRAPPER = `file-item`;
 const CLASS_MAX = `is-max`;

 const SELECTOR_WRAP = `.attach-file-wrap`;
 const SELECTOR_ADD_BTN = `.btn-attach-file`;

 const ADDED_FILE_MAP = new Map();

 const reassignInputNames = (fileListWrap) => {
 const namePrefix =
 fileListWrap.getAttribute(`data-${DATA_NAME_ATTRIBUTE_PREFIX}`) ||
 `attach_file_`;
 const wrapIndex =
 Array.from(
 document.querySelectorAll(`${SELECTOR_WRAP}[data-${DATA_WRAP_NAME}]`),
 ).indexOf(fileListWrap) + 1;
 const fileInputs = fileListWrap.querySelectorAll(`input[type="file"]`);

 fileInputs.forEach((input) => {
 input.name = `${namePrefix}${wrapIndex}`;
 });
 };

 const addFile = ({ target }) => {
 const addBtn = target.closest(SELECTOR_ADD_BTN);

 if (!addBtn) return;

 const wrapName = addBtn.getAttribute(`data-${DATA_WRAP_NAME}`);
 const captureValue = addBtn.getAttribute(`data-${DATA_CAPTURE}`);
 const fileListWrap = document.querySelector(
 `${SELECTOR_WRAP}[data-${DATA_WRAP_NAME}=${wrapName}]`,
 );

 if (!fileListWrap) return;
 if (!ADDED_FILE_MAP.has(fileListWrap))
 ADDED_FILE_MAP.set(fileListWrap, new Set());

 const addedFileList = ADDED_FILE_MAP.get(fileListWrap);
 const fileAccept =
 fileListWrap.getAttribute(`data-${DATA_FILE_ACCEPT}`) || `*`;
 const maxItemSize = Number(
 fileListWrap.getAttribute(`data-${DATA_MAX_ITEM_SIZE}`),
 );
 const maxFileSize = Number(
 fileListWrap.getAttribute(`data-${DATA_MAX_FILE_SIZE}`),
 );

 if (maxItemSize && fileListWrap.childElementCount >= maxItemSize) {
 alert(`최대 ${maxItemSize}개까지 가능합니다.`);
 return;
 }

 const fileInput = document.createElement(`input`);
 fileInput.type = `file`;
 fileInput.title = `첨부파일`;
 fileInput.accept = fileAccept;
 fileInput.style.display = `none`;

 if (captureValue) fileInput.capture = captureValue;

 fileInput.addEventListener(`input`, (event) => {
 const file = event.target.files[0];

 if (!file) return;

 const fileIdentifier = `${file.name}-${file.size}`;

 if (addedFileList.has(fileIdentifier)) {
 alert(`이미 추가된 파일입니다.`);
 return;
 }

 if (maxFileSize && file.size / (1024 * 1024) > maxFileSize) {
 alert(`파일 크기는 최대 ${maxFileSize}MB 까지 가능합니다.`);
 return;
 }

 addedFileList.add(fileIdentifier);

 const itemWrapper = document.createElement(`div`);
 itemWrapper.classList.add(CLASS_ITEM_WRAPPER);

 const fileName = document.createElement(`span`);
 fileName.innerText = file.name;
 fileName.classList.add(`name`);

 const removeButton = document.createElement(`button`);
 removeButton.type = `button`;
 removeButton.title = `삭제`;
 removeButton.innerHTML = `<i class="ico ico-mask ico-close"></i>`;
 removeButton.classList.add(`btn`, `btn-ico`);
 removeButton.dataset.identifier = fileIdentifier;

 itemWrapper.append(fileName, removeButton, fileInput);
 fileListWrap.append(itemWrapper);

 reassignInputNames(fileListWrap);

 fileListWrap.childElementCount === maxItemSize &&
 fileListWrap.classList.add(CLASS_MAX);
 });

 fileInput.click();
 };

 const removeFile = ({ target }) => {
 const removeBtn = target.closest(`.btn-ico`);

 if (!removeBtn) return;

 const fileIdentifier = removeBtn.dataset.identifier;

 if (!fileIdentifier) return;

 const itemWrapper = removeBtn.closest(`.${CLASS_ITEM_WRAPPER}`);
 const fileListWrap = itemWrapper.closest(SELECTOR_WRAP);
 const addedFileList = ADDED_FILE_MAP.get(fileListWrap);

 if (!addedFileList) return;

 fileListWrap.removeChild(itemWrapper);
 addedFileList.delete(fileIdentifier);

 reassignInputNames(fileListWrap);

 const maxItemSize = Number(
 fileListWrap.getAttribute(`data-${DATA_MAX_ITEM_SIZE}`),
 );

 fileListWrap.childElementCount < maxItemSize &&
 fileListWrap.classList.remove(CLASS_MAX);
 };

 const handleClick = ({ target }) => {
 addFile({ target }) || removeFile({ target });
 };

 const initialize = () => {
 document.body.addEventListener(`click`, handleClick);
 };

 initialize();

 attachFileList.cleanup = () => {
 document.body.removeEventListener(`click`, handleClick);
 };
};

export default attachFileList;
